import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CustomInput from "../../../shared/utils/Input";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  updateFormField,
  setFieldError,
  // validateAllFields,
  setSaveButtonClicked,
} from "../../../redux/slices/vendorFormSlice";
import { validatePersonalDetails } from "./vendorValidation";

const PersonalForm = ({ onNext }) => {
  const dispatch = useDispatch();
  const { phone } = useSelector((state) => state.vendorAuth);
  const vendorPrimaryContactNo = phone.replace("+91", "");
  const { formData, errors } = useSelector((state) => state.vendorForm);

  useEffect(() => {
    if (!formData.ownerPrimaryContactNo && vendorPrimaryContactNo) {
      dispatch(
        updateFormField({
          name: "ownerPrimaryContactNo",
          value: vendorPrimaryContactNo,
        })
      );
    }
  }, [dispatch, formData.ownerPrimaryContactNo, vendorPrimaryContactNo]);

  const handleBlur = (e) => {
    const { name, value } = e.target;

    const validationMessages = {
      ownerName: "Please enter the owner's full name.",
      emailAddress: "Please enter your email.",
      vendorBusinessName: "Vendor business name is required.",
      ownerPrimaryContactNo: "Primary contact number cannot be empty.",

      // add more messages
    };

    if (name === "ownerSecondaryContactNo") {
      if (value && !/^\d{10}$/.test(value)) {
        dispatch(
          setFieldError({
            name,
            message: "Enter a valid 10-digit number",
          })
        );
      } else {
        dispatch(setFieldError({ name, message: "" }));
      }
    }

    if (name === "ownerPrimaryContactNo") {
      if (!/^\d{10}$/.test(value)) {
        dispatch(
          setFieldError({ name, message: "Enter a valid 10-digit number" })
        );
      }
    }

    if (validationMessages[name]) {
      if (!value.trim()) {
        dispatch(setFieldError({ name, message: validationMessages[name] }));
      } else {
        dispatch(setFieldError({ name, message: "" })); // clear error
      }
    }

    // if (saveButtonClicked) {
    //   dispatch(validateAllFields());
    // }
  };

  const handleSubmit = () => {
    dispatch(setSaveButtonClicked(true));
    const isValid = validatePersonalDetails(formData, dispatch);

    if (isValid) {
      onNext();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "ownerName") {
      if (!/^[a-zA-Z\s]*$/.test(value)) return;
    }

    if (name === "ownerPrimaryContactNo") {
      if (value.length > 10) {
        return;
      }
      if (!/^\d*$/.test(value)) return; // Block non-numeric input
    }

    if (name === "ownerSecondaryContactNo") {
      if (value.length > 10) {
        return;
      }
    }

    if (!value.startsWith(" ")) {
      dispatch(updateFormField({ name, value }));
    }
  };
  return (
    <div className=" max-w-md">
      <div>
        <h1 className="text-3xl font-bold mb-4">Personal Details</h1>
        <p className="mb-6">
          Please tell us more about yourself to personalise your data and for
          seamless interaction.
        </p>
      </div>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CustomInput
              placeholder="Enter Full Name"
              size="small"
              title="Full Name *"
              name="ownerName"
              value={formData.ownerName}
              onChange={handleChange}
              onBlur={handleBlur}
              error={!!errors.ownerName}
              errorMessage={errors.ownerName}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              placeholder="Enter Email"
              title="Email *"
              size="small"
              name="emailAddress"
              value={formData.emailAddress}
              onChange={handleChange}
              onBlur={handleBlur}
              error={!!errors.emailAddress}
              errorMessage={errors.emailAddress}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              placeholder="Enter Primary Phone Number"
              title="Primary Phone Number *"
              size="small"
              name="ownerPrimaryContactNo"
              value={formData.ownerPrimaryContactNo || vendorPrimaryContactNo}
              onChange={handleChange}
              onBlur={handleBlur}
              error={!!errors.ownerPrimaryContactNo}
              errorMessage={errors.ownerPrimaryContactNo}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              placeholder="Enter Secondary Phone Number"
              title="Secondary Phone Number "
              size="small"
              name="ownerSecondaryContactNo"
              value={formData.ownerSecondaryContactNo}
              onChange={handleChange}
              onBlur={handleBlur}
              error={!!errors.ownerSecondaryContactNo}
              errorMessage={errors.ownerSecondaryContactNo}
            />
          </Grid>
        </Grid>
      </Box>
      <div className=" mt-4 flex justify-end">
        <Button onClick={handleSubmit} variant="contained">
          Next
        </Button>
      </div>
    </div>
  );
};

export default PersonalForm;
